export class Visa {

	submit(parent)
	{
		let form = $(parent);
		let _this = this;

		form.find('input[type=submit]').attr('disabled', true);
		form.find('.form__loader').addClass('active');

		let formData = new FormData(parent);

		fetch('/ajax.php?mid=17&action=sendForm', {
			method: 'POST',
			body: formData,
		})
		.then(response => response.json())
		.then(res => {
			console.log(res);
			form.find('.form__loader').removeClass('active');

			if (res.success)
			{
				form.find('.form__mistakes').text('');
				$('.visa-application').replaceWith(res.html);
			}
			else
			{
				form.find('.form__mistakes').text(res.error);
			}
		})
		.catch(error => {
			console.log(error);
			form.find(' .form__loader').removeClass('active');
			form.find('.form__mistakes').text(error);
		});
	}

	checkVisaSimple (parent)
	{
		let _this = this;
		let form = $(parent);

		$.ajax({
			url: "/ajax.php?mid=17&action=checkVisaSimple",
			type: 'POST',
			data: form.serialize(),
			dataType: "html",
			success: function(html){
				$('.visa-check__answer--simple').replaceWith(html);
				form.closest('.visa-check-main').find('.visa-check__answer-wrapper').slideDown();
			},
			error: function(err){
				if (err.statusText === "abort") {
            // Запрос был прерван, можно просто проигнорировать
            console.warn('Запрос был прерван.');
        } else {
            // Обработка остальных ошибок
            alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
        }
			}
		});
	}

	checkVisaComplex (parent)
	{
		let _this = this;
		let form = $(parent);

		$.ajax({
			url: "/ajax.php?mid=17&action=checkVisaComplex",
			type: 'POST',
			data: form.serialize(),
			dataType: "html",
			success: function(html){
				$('.visa-check__answer--complex').replaceWith(html);
				form.closest('.visa-check-main').find('.visa-check__answer-wrapper').slideDown();
			},
			error: function(err){
				if (err.statusText === "abort") {
            // Запрос был прерван, можно просто проигнорировать
            console.warn('Запрос был прерван.');
        } else {
            // Обработка остальных ошибок
            alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
        }
			}
		});
	}

	checkVisaVFTF (parent)
	{
		let _this = this;
		let form = $(parent);

		$.ajax({
			url: "/ajax.php?mid=17&action=checkVisaVFTF",
			type: 'POST',
			data: form.serialize(),
			dataType: "html",
			success: function(html){
				$('.visa-check__answer--vftf').replaceWith(html);
			},
			error: function(err){
				if (err.statusText === "abort") {
            // Запрос был прерван, можно просто проигнорировать
            console.warn('Запрос был прерван.');
        } else {
            // Обработка остальных ошибок
            alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
        }
			}
		});
	}

	countEdit(parent, num)
	{
		let el = $(parent).closest('.visa-adding');
		num += parseInt(el.find('input[name=count]').val());
		if (num < 1)
			num = 1;
		let price = el.find('.form__choice-list li input:checked').attr('data-price');
		el.find('input[name=count]').val(num);
		el.find('.visa-adding__counter-value').text(num + '\u00A0шт');
		el.find('.visa-adding__price').text('$\u00A0' + num * price);
	}

	recalc(parent)
	{
		let el = $(parent).closest('.visa-adding');
		let num = parseInt(el.find('input[name=count]').val());
		let price = $(parent).attr('data-price');
		el.find('.visa-adding__price').text('$\u00A0' + num * price);
	}

	applyEvents()
	{
		$('.visa-form__choice input[type=radio]').change(function(){
			let el = $(this);
			if (el.val() == 1)
			{
				el.closest('.visa-form__choice').find('.visa-form__choice-more').slideDown();
				el.closest('.visa-form__choice').find('textarea').prop('disabled', false);
			}
			else
			{
				el.closest('.visa-form__choice').find('.visa-form__choice-more').slideUp();
				el.closest('.visa-form__choice').find('textarea').prop('disabled', true);
			}
		});

		$('.form-file__input').change(function(){
			let el = $(this);
			let fileItem = el.closest('.form__item');
			let mistakeEl = fileItem.find('.form__item-mistake');
			
			if (this.files.length)
			{
				let file = this.files[0];
				let maxSize = 1048576; // 1 МБ в байтах
				
				// Проверяем размер файла
				if (file.size > maxSize) {
					// Показываем ошибку
					mistakeEl.slideDown().text('Размер файла не должен превышать 1 МБ');
					el.removeClass('valid').addClass('invalid');
					el[0].setCustomValidity('Размер файла не должен превышать 1 МБ');
					
					// Очищаем файл
					el.val('');
					return;
				}
				
				// Если файл корректный, очищаем ошибку и показываем файл
				mistakeEl.slideUp().text('');
				el.removeClass('invalid').addClass('valid');
				el[0].setCustomValidity('');
				
				el.closest('.form-file').find('.files-results__item-title').text(file.name);
				el.closest('.form-file').find('.form-file__btn--upload').removeClass("active");
				el.closest('.form-file').find('.form-file__btn--change').addClass("active");
				el.closest('.form-file').find('.form-file__results').slideDown();
			}
			else
			{
				// Очищаем ошибку при удалении файла
				mistakeEl.slideUp().text('');
				el.removeClass('invalid valid');
				el[0].setCustomValidity('');
				
				el.closest('.form-file').find('.form-file__btn--change').removeClass("active");
				el.closest('.form-file').find('.form-file__btn--upload').addClass("active");
				el.closest('.form-file').find('.form-file__results').slideUp();
				el.closest('.form-file').find('.files-results__item-title').text('');
			}
		});

		$('.files-results__item-delete').click(function(){
			let el = $(this);
			el.closest('.form-file').find('.form-file__input').val('').trigger('change');
		});

		$('input.restrict').on('input', function(){
			let el = $(this);
			let val = el.val();
			let valid = true;
			let error = '';
			
			if (el.hasClass('restrict-number'))
			{
				if (val.match(/[^0-9]/))
				{
					valid = false;
					error = 'Только цифры';
				}
			}
			
			if (el.hasClass('restrict-phone'))
			{
				if (val.match(/[^0-9\+\- \(\)]/))
				{
					valid = false;
					error = 'Только цифры, скобки, тире и +';
				}
			}
			
			if (el.hasClass('restrict-latin'))
			{
				if (val.match(/[^a-zA-Z \-]/))
				{
					valid = false;
					error = 'Только латинские символы';
				}
			}

			if (el.hasClass('restrict-email'))
			{
				if (val.match(/[^a-zA-Z0-9_@\.\-]/))
				{
					valid = false;
					error = 'Только латинские символы, цифры, точка, тире и @';
				}
			}

			console.log(valid);
			console.log(error);

			if (valid)
			{
				el.removeClass('invalid');
				el[0].setCustomValidity('');
				el.closest('.form__item').find('.form__item-mistake').slideUp().text('');
			}
			else
			{
				el.addClass('invalid');
				el[0].setCustomValidity(error);
				el.closest('.form__item').find('.form__item-mistake').slideDown().text(error);
			}
		});

		// Обработчик фокуса на скрытом поле даты - открываем календарь
		$('input[name="dte_arrival_date"]').on('focus', function() {
			let field = $(this);
			let calendar = field.closest('.form__item-main').find('.settings-date__calendar');
			
			// Открываем календарь только если он ещё не открыт
			if (!calendar.hasClass('active')) {
				calendar.addClass('active');
				config.openCalendar();
			}
		});

		// Блокируем ввод с клавиатуры в поле даты (имитируем readonly)
		$('input[name="dte_arrival_date"]').on('keydown keypress keyup input', function(e) {
			e.preventDefault();
			return false;
		});
	}
}